module.exports = __webpack_public_path__ + "img/created_mind.77d24646.svg";